import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {

  constructor(private router: Router) { }
  navigateToContractor(contractorInternalId: number | string | null): void {
    if (contractorInternalId) {
      this.router.navigate(['/contractor', contractorInternalId]);
    }
  }

  navigateToMachine(machineInternalId: number | string | null): void {
    if (machineInternalId) {
      this.router.navigate(['/machine', machineInternalId]);
    }
  }

  navigateToTeamById(team: { id: number } | null): void {
    if (team?.id == null || team?.id == undefined) {
      return;
    }

    this.router.navigate(['/team', team.id]);
  }
}